import React, { useState, useEffect, useContext } from "react";
import { FaTwitter, FaFacebookF, FaInstagram } from "react-icons/fa";
import FooterBottom from "../FooterBottom";
import { Link } from "react-router-dom";
import { MapContext } from "../../context/MapContext";
import { brandData } from "../../utils/constants";
import { getLogoWithDomain, OtherLogos } from "../../utils/helper";
import "./Footer.scss";

const Footer = () => {
  const { mapValue } = useContext(MapContext);
  const [currentHQ, setCurrentHQ] = useState(null);

  useEffect(() => {
    const hq = brandData.find((item) => item.slug === mapValue);
    setCurrentHQ(hq || brandData[0]);
  }, [mapValue]);

  return (
    <> 
      <div class="footer-section m-3 m-md-5 mt-0 p-3 p-md-5 mt-md-3">
        <div class="container-fluid">
          <div class="row align-items-center mb-4">
            <div class="col-md-6 d-flex justify-content-start footer-logo-badges">
              <div
                className="d-flex align-items-center justify-content-start justify-content-md-start mb-4 mb-md-0"
                style={{
                  marginTop: "14px",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <img
                  src={getLogoWithDomain(mapValue)}
                  style={{
                    width: "110px",
                  }}
                  alt="K-PAK Logo"
                />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <OtherLogos mainDomain={mapValue} />
                </div>
              </div>
            </div>
            <div class="col-md-6 d-flex justify-content-start gap-2 justify-content-md-end footer-social-icons">
              <div
                className="icon-wrap-round"
                onClick={() => window.open(brandData.find((item) => item.slug === mapValue).facebook, "_blank")}
              >
                <FaFacebookF className="social-icon" />
              </div>
              <div
                className="icon-wrap-round"
                onClick={() => window.open(brandData.find((item) => item.slug === mapValue).twitter, "_blank")}
              >
                <FaTwitter className="social-icon" />
              </div>
              <div
                className="icon-wrap-round"
                onClick={() => window.open(brandData.find((item) => item.slug === mapValue).instagram, "_blank")}
              >
                <FaInstagram className="social-icon" />
              </div>
            </div>
          </div>

          <div class="footer-divider"></div>

          <div class="row mt-4 justify-content-between">
            <div class="col-md-6">
              <div class="row">
              <div class="col-6 col-md-3 footer-links">
              <h5>Useful Links</h5>
              <ul>
                <li>
                  <Link to="/factories">Factories</Link>
                </li>
                <li>
                  <Link to="/certificates">Certificates</Link>
                </li>
                <li>
                  <Link to="/events">Events</Link>
                </li>
              </ul>
            </div>

            
            <div class="col-6 col-md-3 footer-links">
              <h5>Quick Links</h5>
              <ul>
                <li>
                  <Link to="http://kuwaitpack.com/catalogue.pdf" target="_blank">
                    Product Catalogue
                  </Link>
                </li>
                <li>
                  <Link to="/about">About us</Link>
                </li>
                <li>
                  <Link to="/career">Career</Link>
                </li>
              </ul>
            </div>
              </div>

            </div>
  

            {currentHQ &&
              currentHQ.links.map((link, index) => (
                <div class="col-md-2 footer-contact-info">
                  {index === 0 && <h5>Head Quarters</h5>}
                  <p>{link.name}</p>
                  <p>
                    <a href={`tel:${link.phone}`}>{link.phone}</a>
                  </p>
                  <p>
                    <a href={`https://wa.me/${link.mob.replace(/\s/g, "")}`} target="_blank">
                      {link.mob}
                    </a>
                  </p>

                  <p>
                    <a href={`mailto:${link.email}`}>{link.email}</a>
                  </p>
                </div>
              ))}
          </div>

          <FooterBottom />
        </div>
      </div>
    </>
  );
};

export default Footer;
